import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Cache the providers at module level to avoid redundant API calls
let cachedProviders = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export function useOAuthProviders() {
  const [providers, setProviders] = useState(cachedProviders || []);
  const [loading, setLoading] = useState(!cachedProviders);

  useEffect(() => {
    const loadProviders = async () => {
      // Return cached if still valid
      if (cachedProviders && cacheTimestamp && (Date.now() - cacheTimestamp < CACHE_DURATION)) {
        setProviders(cachedProviders);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/auth/oauth/providers`);
        if (response.ok) {
          const data = await response.json();
          const providerList = data.providers || [];
          cachedProviders = providerList;
          cacheTimestamp = Date.now();
          setProviders(providerList);
        }
      } catch (error) {
        console.log('OAuth providers not configured');
      } finally {
        setLoading(false);
      }
    };

    loadProviders();
  }, []);

  return { providers, loading };
}

// Clear cache (useful for admin changes)
export function clearOAuthProvidersCache() {
  cachedProviders = null;
  cacheTimestamp = null;
}
